import React from 'react';
import { GlobalErrorView } from '@bingads-webui/ads-copilot-ui';
import { I18nModel } from '@bingads-webui/copilot-i18n';

interface IMSAGlobalErrorViewProps {
  onCopilotClose?(): void;
  onRefresh?(): void;
  i18n: I18nModel
}

export const MSAGlobalErrorView: React.FC<IMSAGlobalErrorViewProps> = React.memo(({
  onCopilotClose,
  onRefresh,
  i18n,
}) => (
  <GlobalErrorView
    onClose={onCopilotClose}
    onRefresh={onRefresh}
    errorTitle={i18n.getString(_TL_('There is some error here'))}
    errorText={i18n.getString(_TL_("We've encountered an error and can't continue. Please contact support for further assistance."))}
  />
));
